<template>
  <transition name="slide-fade-delay">
    <section
      v-if="this.$store.state.selectedType == 1 || this.$store.state.selectedType == 3 || this.$store.state.edit_slots[3]"
      class="content-block small-padding"
    >
      <div class="slot block has-white-background">
        <div
          class="inner-block is-flex"
          id="talfahrt_uhrzeit"
        >
          <div class="col-2">
            <div class="title-container">
              <h1 class="title">
                {{ $t("sequenceLabels.tour.3") }}
              </h1>
              <InctInfoElement>
                <p
                  class="subtitle"
                  v-html="$t('fahrtView.label.tourDescentHint')"
                />
              </InctInfoElement>
            </div>
          </div>
          <div class="line-element"/>
          <div
            v-if="this.$store.state.fetch_GET_Content_Talfahrt && !this.$store.state.isLoading"
            class="slots is-flex"
          >
            <div
              v-for="(slot, i) in this.$store.state.fetch_GET_Content_Talfahrt"
              :key="i"
              class="slot col-6"
              :class="[
                { active: slot.id == $store.state.talfahrt_Slot_ID },
                { dated: slot.isSlotExpired == true },
                { low_capacity: getAvailableSlotCapacity(slot) < $store.state.ticket_reservation_amount },
                { full: getAvailableSlotCapacity(slot) == 0 },
                { booked: slot.id == $store.state.booking_talfahrt_Slot_ID },
                { all_day: $store.state.fetch_GET_Content_Talfahrt.length === 1 }]"
              @click="selectTalfahrtSlotFn(slot)"
            >
              <h2 class="time">
                <div v-if="$store.state.fetch_GET_Content_Talfahrt.length > 1">
                  {{ slot.startTimeFormatted }}
                  {{ $t("general.label.clock") }}
                </div>
                <div v-else>
                  08:10 - 17:10 {{ $t("general.label.clock") }}
                </div>
              </h2>
              <p v-if="slot.isSlotExpired">
                {{ $t("fahrtView.label.slotExpired") }}
              </p>
              <p v-else-if="slot.id == $store.state.booking_talfahrt_Slot_ID">
                {{ $t("fahrtView.label.slotBooked") }}
              </p>
              <p v-else-if="$store.state.fetch_GET_Content_Talfahrt.length === 1">
                {{ $t("fahrtView.label.descentCanBeAtAnyTimeHint") }}
              </p>
              <p v-else-if="getAvailableSlotCapacity(slot) == 0">
                {{ $t("fahrtView.label.slotSoldOut") }}
              </p>
              <p v-else-if="getAvailableSlotCapacity(slot) < $store.state.ticket_reservation_amount">
                {{
                  $t("fahrtView.label.slotCapacity", {
                    capacityLeft: slot.capacity -
                      slot.capacityReserved, capacity: slot.capacity
                  })
                }}
              </p>
              <p
                v-else
                :class="{ limited: check_capacityReservedFn(slot) }"
              >
                {{
                  $t("fahrtView.label.slotCapacity", {
                    capacityLeft: getAvailableSlotCapacity(slot),
                    capacity: slot.capacity
                  })
                }}
              </p>
            </div>
            <div v-if="this.$store.state.fetch_GET_Content_Talfahrt.length === 0">
              <p class="connection-note">
                <font-awesome-icon icon="info-circle"/>
                {{ $t("fahrtView.label.noSlotsFound") }}
                <br><b>{{ $t("editView.label.noDescentAvailableOnThisDay") }}</b>
              </p>
            </div>
          </div>
          <div
            v-else-if="this.$store.state.isLoading"
            class="loading-block"
          >
            <div class="control is-small is-loading">
              <p class="connection-note loading">
                {{ $t("general.label.loadingContents") }}
              </p>
            </div>
          </div>
          <div
            v-else
            class="is-flex"
          >
            <p class="connection-note">
              <font-awesome-icon icon="info-circle"/>
              {{ $t("general.label.noDataFound") }}
            </p>
          </div>
        </div>
      </div>
    </section>
  </transition>
</template>

<script>
import {watch} from "vue";
import InctInfoElement from "@/components/info-element/InctInfoElement.vue";

export default {
  name: 'FahrtAuswahl',
  components: {InctInfoElement},
  data() {
    return {
      active: false,
      dated: false
    }
  },
  mounted() {
    this.$store.show_Component_TalfahrtUhrzeit = true;
    watch(() => this.$store.state.bergfahrt_Slot_ID, () => {
      if (this.$store.state.selectedType == 1 || this.$store.state.selectedType == 3 || this.$store.state.edit_slots[3]) {
        const ascentSlot = this.$store.state.fetch_GET_Content_Bergfahrt.find((s) => s.id === this.$store.state.bergfahrt_Slot_ID);
        if (ascentSlot) {
          const time = new Date(ascentSlot.startTime);
          time.setTime(time.getTime() + (2.5 * 60 * 60 * 1000));
          const searchTime = time.getHours() + ':' + (time.getMinutes() === 0 ? '00' : time.getMinutes());
          const slot = this.$store.state.fetch_GET_Content_Talfahrt.find((s) => s.startTimeFormatted === searchTime);
          if (slot) {
            if(this.getAvailableSlotCapacity(slot)) {
              this.selectTalfahrtSlotFn(slot, true);
            }
          } else {
            this.selectTalfahrtSlotFn(this.$store.state.fetch_GET_Content_Talfahrt[this.$store.state.fetch_GET_Content_Talfahrt.length - 1], true);
          }
        }
      } else {
        this.$store.state.talfahrt_Slot_ID = null;
        this.$store.state.talfahrt_EventDate_ID = null;
        this.$store.state.talfahrt_Slot_Time = '';
      }
    });
  },
  destroyed() {
  },
  methods: {
    selectTalfahrtSlotFn(slot, noScroll = false) {
      this.$store.state.talfahrt_Slot_ID = slot.id;
      this.$store.state.talfahrt_EventDate_ID = slot.eventDate.id;
      this.$store.state.talfahrt_Slot_Time = slot.startTimeFormatted;

      if (document.querySelector("#bergfahrt_uhrzeit") && !noScroll) {
        this.$scrollTo('#bergfahrt_uhrzeit', '2000')
      }
    },
    check_capacityReservedFn(slot) {
      let check_Sum = this.getAvailableSlotCapacity(slot);
      if (check_Sum <= 10) {
        return true
      }
    },
    getAvailableSlotCapacity(slot) {
      return slot.capacity - slot.capacityReserved - (slot.capacityInCart ? slot.capacityInCart : 0);
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.title-container {
  margin-bottom: 1.4rem !important;
}

.slots {
  width: 100%;
  position: relative;
  display: block;

  &.is-flex {
    flex-wrap: wrap;
  }

  .slot {
    width: 13%;
    height: auto;
    display: block;
    position: relative;
    margin-right: 1%;
    margin-top: 1%;
    border: 1px solid rgba(200, 200, 200, 1);
    border-radius: 2px;
    text-align: center;
    padding: 0.25rem 0rem;
    cursor: pointer;
    transition: all 0.2s ease-in-out;

    &:nth-child(7n) {
      margin-right: 0;
    }

    &.all_day {
      width: 100%;
      margin-right: 0%;
    }

    &.dated,
    &.low_capacity,
    &.full {
      background-color: rgba(200, 200, 200, 1);
      opacity: 0.4;
      pointer-events: none;

      p {
        color: #4a4a4a;
      }
    }

    p {
      font-size: 11px;
      margin-top: -1px;
      font-weight: 500;
      color: #6AB25C;

      &.limited {
        color: #EB8C2D;
      }
    }

    &:hover {
      border: 1px solid rgba(150, 150, 150, 1);
      box-shadow: 0px 2px 6px rgba(35, 35, 35, 0.1);
    }

    &.booked {
      background-color: #004e9f;
      color: rgba(255, 255, 255, 0.8);
      border: 1px solid #004e9f;
      opacity: 0.5;

      p {
        color: rgba(255, 255, 255, 0.8);
      }
    }

    &.active {
      background-color: #004e9f;
      color: rgba(255, 255, 255, 0.8);
      border: 1px solid #004e9f;

      p {
        color: rgba(255, 255, 255, 0.8);
      }
    }
  }
}

.line-element {
  width: 100%;
  height: 1px;
  background-color: rgb(200, 200, 200);
  margin-top: -0.55rem;
}

@media all and (min-width: 680px) and (max-width: 800px) {

}

@media (max-width: 680px) {
  .content-block {
    .slots .slot {
      width: 32%;
      margin-right: 2%;
      margin-top: 2%;

      &:nth-child(3n) {
        margin-right: 0 !important;
      }

      &:nth-child(7n) {
        margin-right: 2%;
      }
    }

    .block.slot {
      .subtitle {
        margin-bottom: 0.6em;
      }
    }
  }
}
</style>
